<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title">
          {{ $t("configRevenueCode.revenueCodeService") }}
        </h3>
      </div>
      <div class="box-body">
        <div>
          <b-table striped hover :fields="gridColumns" :items="items">
            <template #head()="data">
              {{ $t(data.label) }}
            </template>
            <template #cell(monthlyInvoice)="row">
              <i
                v-if="row.item.monthlyInvoice"
                style="font-size: x-large; color: green"
                class="glyphicon glyphicon-ok-sign"
              ></i>
              <i
                v-else
                style="font-size: x-large; color: red"
                class="glyphicon glyphicon-remove-sign"
              ></i>
            </template>
            <template #cell(actions)="data">
              <div class="btn-group">
                <button
                  class="btn btn-primary btn-sm"
                  style="margin-left: 6px"
                  :title="$t('common.edit')"
                  @click="onEditConfigRevenueCode(data.item)"
                >
                  <i class="glyphicon glyphicon-edit"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
        <div
          class="box-footer clearfix"
          style="display:contents;"
          v-if="items.length > 0"
        >
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
      </div>
    </div>
    <!--  -->
    <div
      class="modal fade"
      :ref="`modal-config-revenue-code`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("configRevenueCode.modalTitle") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("service.service_code") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="configRevenueCodeData.serviceCode"
                    disabled
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("service.serviceList.serviceName")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="configRevenueCodeData.serviceName"
                    disabled
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("configRevenueCode.title") }}</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="configRevenueCodeData.code"
                  />
                </div>
              </div>
              <div class="col-md-12" v-if="!configRevenueCodeData.isBuiltinService">
                  <div class="form-group">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="checkboxMonthlyInvoice"
                        v-model="configRevenueCodeData.monthlyInvoice"
                      />
                      <label class="form-check-label" for="checkboxMonthlyInvoice">{{
                        $t("service.monthlyInvoice")
                      }}</label>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button type="button" class="btn btn-primary" @click="onSave">
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Paginator from "@/components/CustomPaginator.vue";

export default {
  components: {
    paginator: Paginator,
    "lte-core-alert": LTECoreAlert
  },
  data: () => ({
    gridColumns: [
      {
        key: "nonumber",
        label: "common.nonumber",
        class: "text-center"
      },
      {
        key: "serviceCode",
        label: "service.service_code"
      },
      {
        key: "serviceName",
        label: "service.serviceList.serviceName"
      },
      {
        key: "revenueCode",
        label: "configRevenueCode.title",
        class: "text-center"
      },
      {
        key: "monthlyInvoice",
        label: "common.monthlyInvoice",
        class: "text-center"
      },
      {
        key: "actions",
        label: "common.action",
        class: "text-center"
      }
    ],
    items: [],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    configRevenueCodeData: {
      id: null,
      serviceName: null,
      serviceCode: null,
      code: null,
      monthlyInvoice: false,
      isBuiltinService: false,
      serviceId: null
    }
  }),
  watch: {
    GET_CONFIG_REVENUE_CODE_DATA: function() {
      let paginate = this.GET_CONFIG_REVENUE_CODE_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_CONFIG_REVENUE_CODE_DATA.results;
      this.items = [];
      data.forEach((value, index) => {
        let nonumber =
          index +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: nonumber,
          serviceCode: value.servicecode,
          serviceName: value.name,
          isBuiltinService: value.is_builtin,
          revenueCode: value.revenue_code.code,
          monthlyInvoice: value.revenue_code.monthly_invoice,
          revenueCodeId: value.revenue_code.id
        };
        this.items.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_CONFIG_REVENUE_CODE_DATA"
    ])
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    getConfigRevenueCodeList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_CONFIG_REVENUE_CODE(filter);
    },
    onPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getConfigRevenueCodeList(data);
    },
    onShowModalConfigRevenueCode: function() {
      $(this.$refs[`modal-config-revenue-code`]).modal("show");
    },
    onHideModalConfigRevenueCode: function() {
      $(this.$refs[`modal-config-revenue-code`]).modal("hide");
    },
    onEditConfigRevenueCode: function(data) {
      this.configRevenueCodeData = {
        id: data.revenueCodeId,
        serviceName: data.serviceName,
        serviceCode: data.serviceCode,
        isBuiltinService: data.isBuiltinService,
        code: data.revenueCode,
        monthlyInvoice: data.monthlyInvoice,
        serviceId: data.id
      };
      this.onShowModalConfigRevenueCode();
    },
    onSave: function() {
      if (utils.isEmptyString(this.configRevenueCodeData.code)) {
        this.showError("configRevenueCode.title");
      } else {
        let data = {
          id: this.configRevenueCodeData.id,
          serviceId: this.configRevenueCodeData.serviceId,
          code: this.configRevenueCodeData.code,
          monthlyInvoice: this.configRevenueCodeData.monthlyInvoice
        };
        if (this.configRevenueCodeData.id) {
          this.UPDATE_CONFIG_REVENUE_CODE(data)
            .then(
              function() {
                this.getConfigRevenueCodeList(this.paginateData.currentPage);
                this.onHideModalConfigRevenueCode();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                let mess = error.response.data.message;
                this.showError(mess);
              }.bind(this)
            );
        } else {
          this.CREATE_CONFIG_REVENUE_CODE(data)
            .then(
              function() {
                this.getConfigRevenueCodeList(this.paginateData.currentPage);
                this.onHideModalConfigRevenueCode();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                let mess = error.response.data.message;
                this.showError(mess);
              }.bind(this)
            );
        }
      }
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_CONFIG_REVENUE_CODE",
      "CREATE_CONFIG_REVENUE_CODE",
      "UPDATE_CONFIG_REVENUE_CODE"
    ])
  },
  mounted() {
    this.getConfigRevenueCodeList(1);
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/Project/ConfigRevenueCode.vue